import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import { injectTracking } from "@fresh8/ad-data-composition/src/tracking";
import { AnalyticEvents } from "@fresh8/types/src/analytics";
interface PixelMacros {
  sport?: string;
  marketId?: string;
  eventName?: string;
  eventId?: string;
  competitor?: string;
  competition?: string;
}

export function usePixelMacros(): {
  getPixelUrl: (eventName: AnalyticEvents) => string;
  getPixelType: () => "image" | "iframe";
  getPixelMacroData: ({
    marketId,
    eventId
  }: {
    marketId?: string | undefined;
    eventId?: string | undefined;
  }) => PixelMacros | null;
  populatePixelUrl: (pixelMacroData: PixelMacros, pixelUrl: string) => string;
} {
  const betData = injectBetData();
  const trackingContext = injectTracking();
  const searchParams = new URLSearchParams(window.location.search);
  const backgroundClickThroughPixel =
    searchParams.get("backgroundClickThroughPixel") || undefined;

  const getPixelMacroData = ({
    marketId,
    eventId
  }: {
    marketId?: string;
    eventId?: string;
  }): PixelMacros | null => {
    const market =
      marketId && betData?.markets.value
        ? betData.markets.value[marketId]
        : null;
    const event = market
      ? betData?.events.value && betData?.events.value[market.eventId]
      : eventId
      ? betData?.events.value && betData?.events.value[eventId]
      : null;

    if (!market || !event) {
      return null;
    }

    return {
      sport: event?.sport,
      marketId: market?.marketId,
      eventName: event?.name,
      eventId: market?.eventId,
      competitor:
        event?.competitors?.home && event?.competitors?.away
          ? event.competitors.home.name.full +
            "," +
            event.competitors.away.name.full
          : undefined,
      competition: event?.competition
    };
  };

  const getPixelUrl = (eventName: AnalyticEvents): string => {
    if (
      trackingContext.value.pixels.clickThroughUrl &&
      eventName === AnalyticEvents.CLICKED_THROUGH
    ) {
      return (
        backgroundClickThroughPixel ||
        trackingContext.value.pixels.clickThroughUrl
      );
    }

    if (
      eventName === AnalyticEvents.VIEWED ||
      eventName === AnalyticEvents.IMPRESSION
    ) {
      return trackingContext.value.pixels.impressionUrl;
    }

    return "";
  };

  const getPixelType = (): "image" | "iframe" => {
    return trackingContext.value.pixels.pixelType;
  };

  const populatePixelUrl = (
    pixelMacroData: PixelMacros,
    pixelUrl: string
  ): string => {
    if (pixelMacroData.sport) {
      pixelUrl = pixelUrl.replace("{sport}", pixelMacroData.sport);
    }
    if (pixelMacroData.marketId) {
      pixelUrl = pixelUrl.replace("{marketID}", pixelMacroData.marketId);
    }
    if (pixelMacroData.eventName) {
      pixelUrl = pixelUrl.replace("{eventName}", pixelMacroData.eventName);
    }
    if (pixelMacroData.eventId) {
      pixelUrl = pixelUrl.replace("{eventID}", pixelMacroData.eventId);
    }
    if (pixelMacroData.competitor) {
      pixelUrl = pixelUrl.replace("{competitor}", pixelMacroData.competitor);
    }
    if (pixelMacroData.competition) {
      pixelUrl = pixelUrl.replace("{competition}", pixelMacroData.competition);
    }
    return pixelUrl;
  };

  return {
    getPixelUrl,
    getPixelType,
    getPixelMacroData,
    populatePixelUrl
  };
}
